// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"9d03cc3b","513":"19a1491b","703":"d6bfab34","787":"17c005c5"}[chunkId] + ".chunk.js";
};